import "./styles.scss";

import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";

import dynamicContentMock from "./mock";
import LessonFooter from "../../components/dynamicContent/LessonFooter";
import LessonHeader from "../../components/dynamicContent/LessonHeader";
import CollabStatusBar from "../../components/dynamicContent/CollabStatusBar";
import PhaseNavigation from "../../components/dynamicContent/PhaseNavigation";
import ParticipantsCard from "../../components/dynamicContent/ParticipantsCard";
import ReferenceSheetCard from "../../components/dynamicContent/ReferenceSheetCard";

const buildThemeStyle = (theme) => {
  if (!theme) return {};
  const { tokens = {}, baseColor } = theme;
  return {
    "--dc-accent": tokens.accentText || baseColor,
    "--dc-page-bg": tokens.pageBackground,
    "--dc-card-bg": tokens.cardBackground,
    "--dc-card-bg-alt": tokens.cardBackgroundAlt,
    "--dc-card-border": tokens.cardBorder,
    "--dc-text": tokens.primaryText,
    "--dc-text-inverse": tokens.inverseText,
  };
};

const DynamicContent = () => {
  const navigate = useNavigate();

  // No futuro substituir por chamada a `GET /api/frontend/sessions/{id}/fixed-cards`.
  const data = dynamicContentMock;

  const [activeSection, setActiveSection] = useState(data.navigationState?.currentSectionIndex ?? 0);

  const themeStyle = useMemo(() => buildThemeStyle(data.theme), [data.theme]);

  const handleBack = () => navigate("/");

  return (
    <div className="dynamicContent" style={themeStyle}>
      <CollabStatusBar initialRole={data.collab?.role} initialStatus={data.collab?.status} />

      <div className="dynamicContent__shell">
        <div className="dynamicContent__body">
          <LessonHeader
            onHomeClick={handleBack}
            lessonHeaderCard={data.lessonHeaderCard}
            participantsCard={data.participantsCard}
          />

          <PhaseNavigation
            onBack={handleBack}
            activeIndex={activeSection}
            onChangeSection={setActiveSection}
            sections={data.navigationState?.sections}
          />

          <main className="dynamicContent__main">
            <aside className="dynamicContent__sidebar">
              <ParticipantsCard participantsCard={data.participantsCard} />
              <ReferenceSheetCard pedagogicalContextCard={data.pedagogicalContextCard} />
            </aside>

            <div className="dynamicContent__content">
              <div className="dynamicContent__placeholder">
                Phase content placeholder — seção {activeSection + 1} de {data.navigationState?.sections?.length}.
              </div>
            </div>
          </main>
        </div>

        <LessonFooter message="Personalized Learning Environment • Class 2: Office Roles & Social Small Talk" />
      </div>
    </div>
  );
};

export default DynamicContent;
